var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6317_1794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5721 4.22921L9.03214 3.68309L7.44814 0.274586C7.40226 0.191029 7.33657 0.121708 7.25761 0.07353C7.17865 0.0253521 7.08919 0 6.99815 0C6.9071 0 6.81764 0.0253521 6.73868 0.07353C6.65972 0.121708 6.59403 0.191029 6.54814 0.274586L4.96814 3.68309L1.42814 4.22921C1.3358 4.24346 1.24904 4.28488 1.1777 4.3488C1.10635 4.41271 1.05327 4.49656 1.02445 4.59087C0.995624 4.68517 0.992215 4.78616 1.01461 4.88241C1.037 4.97867 1.08429 5.06635 1.15114 5.13552L3.71315 7.79177L3.10715 11.5381C3.09132 11.6359 3.10158 11.7364 3.13676 11.8283C3.17194 11.9202 3.23063 11.9998 3.30619 12.0581C3.38175 12.1164 3.47116 12.151 3.56429 12.1581C3.65742 12.1651 3.75056 12.1444 3.83314 12.0981L7.00014 10.3258L10.1671 12.0949C10.2386 12.1352 10.3183 12.156 10.3991 12.1555C10.472 12.1556 10.544 12.1389 10.6102 12.1064C10.6763 12.0739 10.7349 12.0264 10.782 11.9673C10.8291 11.9082 10.8634 11.8389 10.8826 11.7642C10.9018 11.6895 10.9054 11.6113 10.8931 11.535L10.2871 7.78859L12.8491 5.13234C12.916 5.06316 12.9633 4.97548 12.9857 4.87923C13.0081 4.78297 13.0047 4.68198 12.9758 4.58768C12.947 4.49337 12.8939 4.40952 12.8226 4.34561C12.7512 4.2817 12.6645 4.24027 12.5721 4.22602V4.22921Z",
    fill: "url(#paint0_linear_6317_1794)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6317_1794",
    x: 0,
    y: 0,
    width: 14,
    height: 14.1602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6317_1794"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6317_1794",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6317_1794",
    x1: 17,
    y1: 6.06787,
    x2: 8.00942e-8,
    y2: 6.06787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E95C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E95C53",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.d1202d56ef0fa1a28aa2743629565ba0.svg";
export { ForwardRef as ReactComponent };